export const colaboradoresOptions = ['1-10', '11-50', '51-99', '100+'];

export const servicosOptions = [
  'UX/UI Design',
  'Identidade Visual',
  'Branding',
  'Aplicativos',
  'SaaS',
  'Websites & Landing Pages',
  'Tráfego Pago',
  'Otimização SEO',
  'Social Media',
];

export const investimentoOptions = [
  'menor que 15mil',
  '15-20mil',
  '20-30mil',
  '30-50mil',
  '50-100mil',
  'maior que 100mil',
];

export const prazoOptions = ['Urgente', '60 dias', '90 dias', 'Sem pressa'];
